// @ vendors
const { Promise } = require('es6-promise');
// @ actions
const signaturePatternActions = require('actions/signaturePattern');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');
const { ACCOUNT_DEBITS_MESSAGE_ANNULATION } = require('constants/index');

const debitAnnulationWillCancel = () => ({
    type: actionTypes.DEBIT_ANNULATION_CANCEL
})

const setDebitAnnulationInProgress = () => ({
    type: actionTypes.DEBIT_ANNULATION_REQUEST
});

const setDebitAnnulationSuccess = (data) => ({
    type: actionTypes.DEBIT_ANNULATION_SUCCESS,
    payload: {
        data
    }
});

const setDebitAnnulationFailure = (error) => ({
    type: actionTypes.DEBIT_ANNULATION_FAILURE,
    payload: {
        error
    }
});

const postDebitCancel = (dispatch, getState, dataToken, receiptToCancel) => {
    const account = getState().accounts.getIn(['byId', receiptToCancel.get('accountId')]);
    const requestData = {
        query: {
            aobsercc: ACCOUNT_DEBITS_MESSAGE_ANNULATION,
            cdinaut: receiptToCancel.get('cdinaut'),
            contrato: {
                numerodecontrato: account.get('newContractNumber'),
                producto: account.get('newProduct')
            },
            dataToken: dataToken,
            tipauto: receiptToCancel.get('tipauto')
        }
    }

    dispatch(setDebitAnnulationInProgress());

    return APIPost(dispatch, apiURLBuilder.getURL('accountDebitCancel'), requestData).then(
        response => {dispatch(setDebitAnnulationSuccess(response))},
        error => {dispatch(setDebitAnnulationFailure(error))}
    );
}

const postDebitCancelValidated = (dispatch, getState, receiptToCancel) => {
    __CONTACT_CENTER__ && dispatch(debitAnnulationWillCancel());
    const callback = (dispatch, getState, dataToken) => {
        postDebitCancel(dispatch, getState, dataToken, receiptToCancel);
    };
    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

const postDebitAnnulation = (receiptToCancel) => (dispatch, getState) => {
    const account = getState().accounts.getIn(['byId', receiptToCancel.get('accountId')]);
    const validationData = {
        query: {
            contrato: {
                numerodecontrato: account.get('newContractNumber'),
                producto: account.get('newProduct')
            },
            ordenRecibo: {
                numerodeorden: receiptToCancel.get('numsor'),
                producto: receiptToCancel.get('codprod')
            }
        }
    }
    const isAlreadyFetching = getState().accountDebitAnnulation.get('isFetching');
    const hasError = getState().accountDebitAnnulation.get('errorReceived') !== '';

    if (!isAlreadyFetching && !hasError){
        dispatch(setDebitAnnulationInProgress());
        return APIPost(dispatch, apiURLBuilder.getURL('accountDebitCancelValidation'), validationData).then(
            () => {dispatch(postDebitCancelValidated(dispatch, getState, receiptToCancel))},
            error => {dispatch(setDebitAnnulationFailure(error))}
        );
    }
}

module.exports = {
    debitAnnulationWillCancel,
    postDebitAnnulation
};
